<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Student Attendance Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="exam_plan" item-value="id"
                        :items="exam_plan_list" item-text="exam_name" label="Exam Plan" outlined
                        persistent-hint hint="Please Select Exam Plan" @change="getExamPlanData()"/>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="conduct_type" item-value="id"
                        :items="conduct_type_list" item-text="conduct_type" label="Exam Conduct Type" outlined persistent-hint
                        hint="Please Select Exam Conduct Type" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stream" item-value="id"
                        :items="stream_list" item-text="stream_name" label="Stream" outlined persistent-hint
                        hint="Please Select Stream" />
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="exam_plan">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="standard" item-value="id"
                        :items="standard_list" item-text="standard" label="Standard" outlined persistent-hint
                        hint="Please Select Standard" @change="getSubjects()"/>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="standard">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="subject" item-value="id"
                        :items="subject_list" item-text="subject_name" label="Subject" outlined persistent-hint
                        hint="Please Select Subject" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="room" item-value="id"
                        :items="room_list" item-text="room_no" label="Room" outlined persistent-hint
                        hint="Please Select Room" />
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="standard">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="student" item-value="id"
                        :items="student_list" item-text="student_name" label="Student" outlined persistent-hint
                        hint="Please Select Student" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="supervisor" item-value="id"
                        :items="supervisor_list" item-text="employee_name" label="Supervisor" outlined persistent-hint
                        hint="Please Select Supervisor" />
                </v-col>
                
            </v-row>
            <v-row justify="center">
                <v-col cols="auto" class="pt-0 pb-0 ml-9">
                    <v-checkbox dense v-model="present" color="success"
                        label="Present"></v-checkbox>
                </v-col>
                <v-col cols="auto" class="pt-0 pb-0 ml-9">
                    <v-checkbox dense v-model="absent" color="success"
                        label="Absent"></v-checkbox>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="auto" class="pt-0 mb-5 ml-9">
                    <v-btn color="primary" @click="fetchAttendanceReport()" small> Fetch </v-btn>
                </v-col>
            </v-row>
          <div v-if="reportFetched">
            <v-row dense align="center">
                        <v-col cols="auto" class="pa-0">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small
                                class="mt-2 ml-2">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export EXCEL
                            </v-btn>
                        </v-col>

                        <v-col cols="auto" class="pa-0 pl-1">
                            <v-btn rounded color="error" outlined @click="printPDF" small class="mt-2">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>

                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details clearable class="search-field"></v-text-field>

            </v-row>
          
            <v-row >
                    <v-col cols="12" sm="" md="2" align="center">
                        <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                        </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                                <h3 class="report_name">Student Attendance Report</h3>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>
           <v-simple-table  fixed-header height="500px" dense class="elevation-1 scroll table-data">
            <thead>
                                <tr>
                                    <th class="sticky-header"><center>S. No.</center></th>
                                    <th class="sticky-header"><center>PRN No.</center></th>
                                    <th class="sticky-header"><center>Roll No.</center></th>
                                    <th class="sticky-header"><center>Student Name</center></th>
                                    <th class="sticky-header"><center>Session No.</center></th>
                                    <th class="sticky-header"><center>Exam Date</center></th>
                                    <th class="sticky-header"><center>Exam Day</center></th>
                                    <th class="sticky-header"><center>Slot No</center></th>
                                    <th class="sticky-header"><center>From Time</center></th>
                                    <th class="sticky-header"><center>To Time</center></th>
                                    <th class="sticky-header"><center>Subject Code</center></th>
                                    <th class="sticky-header"><center>Subject Name</center></th>
                                    <th class="sticky-header"><center>Conduct Type</center></th>
                                    <th class="sticky-header"><center>Room No</center></th>
                                    <th class="sticky-header"><center>Bench No</center></th>
                                    <th class="sticky-header"><center>Bench Side</center></th>
                                    <th class="sticky-header"><center>Supervisor</center></th>
                                    <th class="sticky-header"><center>Standard</center></th>
                                    <th class="sticky-header"><center>Division</center></th>
                                    <th class="sticky-header"><center>Stream</center></th>
                                    <th class="sticky-header"><center>Present(P) / Absent(A)</center></th>
                                    <th class="sticky-header"><center>Exam Plan</center></th>
                                    <th class="sticky-header"><center>Academic Year</center></th>
                                    <th class="sticky-header"><center>Semester</center></th>

                                </tr>
                            </thead>
                            <tbody>
                    <tr v-for="(s, index) in filterStudentAttendenceReport" :key="s.cid || index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ s.prn }}</td>
                        <td>{{ s.rollno }}</td>
                        <td>{{ s.student_name }}</td>
                        <td>{{ s.session_no }}</td>
                        <td>{{ s.exam_date }}</td>
                        <td>{{ s.day }}</td>
                        <td>{{ s.slot_no }}</td>
                        <td>{{ s.from_time }}</td>
                        <td>{{ s.to_time }}</td>
                        <td>{{ s.subject_code }}</td>
                        <td>{{ s.subject_name }}</td>
                        <td>{{ s.conduct_type }}</td>
                        <td>{{ s.room_no }}</td>
                        <td>{{ s.bench_no }}</td>
                        <td>{{ s.bench_side }}</td>
                        <td>{{ s.supervisor }}</td>
                        <td>{{ s.standard }}</td>
                        <td>{{ s.division }}</td>
                        <td>{{ s.stream }}</td>
                        <td>{{ s.present_absent }}</td>
                        <td>{{ s.exam_name }}</td>
                        <td>{{ s.academic_year }}</td>
                        <td>{{ s.semester }}</td>
                    </tr>
                </tbody>
                        

           </v-simple-table>
           </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>

        <div id="pdf-report" class="pdf-report">
            <v-row >
                    <v-col cols="12" sm="" md="2" align="center">
                        <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                        </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                                <h3 class="report_name">Student Attendence Report</h3>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>
         

            <table>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>PRN</th>
                        <th>Roll No</th>
                        <th>Student Name</th>
                        <th>Session No.</th>
                        <th>Exam Date</th>
                        <th>Exam Day</th>
                        <th>Slot No</th>
                        <th>From Time</th>
                        <th>To Time</th>
                        <th>Subject Code</th>
                        <th>Subject Name</th>
                        <th>Conduct Type</th>
                        <th>Room No.</th>
                        <th>Bench No</th>
                        <th>Bench Side</th>
                        <th>Supervisor</th>
                        <th>Standard</th>
                        <th>Division</th>
                        <th>Stream</th>
                        <th>Present(P) / Absent(A)</th>
                        <th>Exam Plan</th>
                        <th>Academic Year</th>
                        <th>Semester</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, index) in attendance_report" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.prn }}</td>
                        <td>{{ item.rollno }}</td>
                        <td>{{ item.student_name }}</td>
                        <td>{{ item.session_no }}</td>
                        <td>{{ item.exam_date }}</td>
                        <td>{{ item.day }}</td>
                        <td>{{ item.slot_no }}</td>
                        <td>{{ item.from_time }}</td>
                        <td>{{ item.to_time }}</td>
                        <td>{{ item.subject_code }}</td>
                        <td>{{ item.subject_name }}</td>
                        <td>{{ item.conduct_type }}</td>
                        <td>{{ item.room_no }}</td>
                        <td>{{ item.bench_no }}</td>
                        <td>{{ item.bench_side }}</td>
                        <td>{{ item.supervisor }}</td>
                        <td>{{ item.standard }}</td>
                        <td>{{ item.division }}</td>
                        <td>{{ item.stream }}</td>
                        <td>{{ item.present_absent }}</td>
                        <td>{{ item.exam_name }}</td>
                        <td>{{ item.academic_year }}</td>
                        <td>{{ item.semester }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
export default {
    data: () => ({
        valid: false,
        overlay: false,
        loader:false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        exam_plan:"",
        conduct_type:"",
        stream:"",
        standard:"",
        subject:"",
        room:"",
        student:"",
        supervisor:"",
        reportFetched: false,
        present:false,
        org_basic_data: [],
        absent:false,
        headers: [
            {
                text: "S.No",
                align: "left",
                sortable: false,
                value: "s_no",
            },
            {
                text: "PRN",
                align: "left",
                sortable: false,
                value: "prn",
            },
            {
                text: "Roll No",
                align: "left",
                sortable: false,
                value: "rollno",
            },
            {
                text: "Student Name",
                align: "left",
                sortable: true,
                value: "student_name",
            },
            {
                text: "Session No.",
                align: "left",
                sortable: true,
                value: "session_no",
            },
            {
                text: "Exam Date",
                align: "left",
                sortable: true,
                value: "exam_date",
            },
            {
                text: "Exam Day",
                align: "left",
                sortable: true,
                value: "day",
            },
            {
                text: "Slot No",
                align: "left",
                sortable: true,
                value: "slot_no",
            },
            {
                text: "From Time",
                align: "left",
                sortable: true,
                value: "from_time",
            },
            {
                text: "To Time",
                align: "left",
                sortable: true,
                value: "to_time",
            },
            {
                text: "Subject Code",
                align: "left",
                sortable: true,
                value: "subject_code",
            },
            {
                text: "Subject Name",
                align: "left",
                sortable: true,
                value: "subject_name",
            },
            {
                text: "Conduct Type",
                align: "left",
                sortable: true,
                value: "conduct_type",
            },
            {
                text: "Room No.",
                align: "left",
                sortable: true,
                value: "room_no",
            },
            {
                text: "Bench No",
                align: "left",
                sortable: true,
                value: "bench_no",
            },
            {
                text: "Bench Side",
                align: "left",
                sortable: true,
                value: "bench_side",
            },
            {
                text: "Supervisor",
                align: "left",
                sortable: true,
                value: "supervisor",
            },
            {
                text: "Standard",
                align: "left",
                sortable: true,
                value: "standard",
            },
            {
                text: "Division",
                align: "left",
                sortable: true,
                value: "division",
            },
            {
                text: "Stream",
                align: "left",
                sortable: true,
                value: "stream",
            },
            {
                text: "Present(P) / Absent(A)",
                align: "left",
                sortable: true,
                value: "present_absent",
            },
            {
                text: "Exam Plan",
                align: "left",
                sortable: true,
                value: "exam_name",
            },
            {
                text: "Academic Year",
                align: "left",
                sortable: true,
                value: "academic_year",
            },
            {
                text: "Semester",
                align: "left",
                sortable: true,
                value: "semester",
            },
        ],
        exam_plan_list: [],
        room_list:[],
        conduct_type_list:[],
        stream_list:[],
        standard_list:[],
        subject_list:[],
        student_list:[],
        supervisor_list:[],
        attendance_report:[],
        editedIndex: -1,
    }),

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    computed: {
    filterStudentAttendenceReport() {
        const data = this.attendance_report || [];
        const query = (this.search || "").toLowerCase().trim();

        if (!query) {
            return data;
        }

        return data.filter(item => {
            return Object.values(item).some(value =>
                String(value == null ? "" : value)
                    .toLowerCase()
                    .includes(query)
            );
        });
    }
},


    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getData")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.exam_plan_list = res.data.exam_plan_list;
                        this.room_list = res.data.room_list;
                        this.supervisor_list = res.data.supervisor_list;

                        if(this.room_list.length>0){
                            this.room_list = [{ id: "All", room_no: "All" },...(res.data.room_list || [])];
                        }
                        if(this.supervisor_list.length>0){
                            this.supervisor_list = [{ id: "All", employee_name: "All" },...(res.data.supervisor_list || [])];
                        }
                        const savedPlan = localStorage.getItem("exam_plan");

                        if (savedPlan) {
                            this.exam_plan = Number(savedPlan);
                            this.getExamPlanData(this.exam_plan)
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getSubjects() {
            const data = {
                exam_plan: this.exam_plan,
                std : this.standard
            }
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getSubjects",data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.subject_list = res.data.subjects_list;
                        this.student_list = res.data.students_list;

                        if(this.subject_list.length>0){
                            this.subject_list = [{ id: "All", subject_name: "All" },...(res.data.subjects_list || [])];
                        }
                        if(this.student_list.length>0){
                            this.student_list = [{ id: "All", student_name: "All" },...(res.data.students_list || [])];
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

         getExamPlanData() {
            const data = {
                exam_plan: this.exam_plan,
            }
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getDataOnExamPlan",data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.conduct_type_list = res.data.conduct_type_list;
                        this.stream_list = res.data.stream_list;
                        this.standard_list = res.data.standard_list;

                        if(this.conduct_type_list.length>0){
                            this.conduct_type_list = [{ id: "All", conduct_type: "All" },...(res.data.conduct_type_list || [])];
                        }
                        if(this.stream_list.length>0){
                            this.stream_list = [{ id: "All", stream_name: "All" },...(res.data.stream_list || [])];
                        }
                        if(this.standard_list.length>0){
                            this.standard_list = [{ id: "All", standard: "All" },...(res.data.standard_list || [])];
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        fetchAttendanceReport() {
            this.overlay = true;
            this.reportFetched = false;
            this.attendance_report = [];
            this.org_basic_data = [];

            const data = {
                exam_plan: this.exam_plan,
                conduct_type: this.conduct_type,
                stream: this.stream,
                standard: this.standard,
                subject: this.subject,
                room: this.room,
                student: this.student,
                supervisor: this.supervisor,
                present: this.present,
                absent: this.absent
            };

            axios
                .post("/SeatingArrangement/fetchStudentAttendanceReport", data)
                .then((res) => {
                    console.log("Attendance API response:", res.data);

                    if (String(res.data.msg) === "200") {
                        this.attendance_report =
                            res.data.attendance_report || [];

                        this.org_basic_data =
                            res.data.org_basic_data || [];

                        if (this.attendance_report.length > 0) {
                            this.reportFetched = true;
                        } else {
                            this.showSnackbar(
                                "#b71c1c",
                                "No attendance details found."
                            );
                        }
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            "No attendance details found."
                        );
                    }
                })
                .catch((error) => {
                    console.error("Attendance report error:", error);
                    this.showSnackbar(
                        "#b71c1c",
                        "Something went wrong..."
                    );
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        downloadFile() {
            this.loader = true;
            const excelData = this.attendance_report.map((item, index) => ({
                "S.No": index + 1,
                "PRN": item.prn,
                "Roll No": item.rollno,
                "Student Name": item.student_name,
                "Session No": item.session_no,
                "Exam Date": item.exam_date,
                "Exam Day": item.day,
                "Slot No": item.slot_no,
                "From Time": item.from_time,
                "To Time": item.to_time,
                "Subject Code": item.subject_code,
                "Subject Name": item.subject_name,
                "Conduct Type": item.conduct_type,
                "Room No": item.room_no,
                "Bench No": item.bench_no,
                "Bench Side": item.bench_side,
                "Supervisor": item.supervisor,
                "Standard": item.standard,
                "Division": item.division,
                "Stream":item.stream,
                "Present(P)/Absent(A)": item.present_absent,
                "Exam Plan":item.exam_name,
                "Academic Year": item.academic_year,
                "Semester": item.semester
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Student Attendance Report");
            XLSX.writeFile(workbook, "StudentAttendanceReport.xlsx");
            this.loader = false;
        },

        printPDF() {
            if (!this.attendance_report || this.attendance_report.length === 0) {
                this.showSnackbar("#b71c1c", "No data available for PDF export.");
                return;
            }

            window.print();
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
.pdf-report {
    display: none;
}

@media print {
    @page {
        size: A3 landscape;
        /* margin: 5mm; */
        margin-left: -40px;
    }

    body * {
        visibility: hidden;
    }

    #pdf-report,
    #pdf-report * {
        visibility: visible;
    }

    #pdf-report {
        display: block !important;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }

    #pdf-report h2 {
        text-align: center;
        font-size: 25px !important;
        font-weight: bold;
        margin: 0 0 10px 0;
    }

    #pdf-report table {
        width: 100%;
        border-collapse: collapse;
        font-size: 16px;
        table-layout: fixed;
    }

    #pdf-report th {
        font-size: 14px !important;
        font-weight: bold;
        padding: 5px 3px;
        border: 1px solid #000;
        text-align: center !important;
        vertical-align: middle !important;
        word-break: break-word;
    }

    #pdf-report td {
        border: 1px solid #000;
        padding: 3px;
        text-align: center !important;
        vertical-align: middle !important;
        word-break: break-word;
        font-size: 12px !important;
    }

    #pdf-report thead {
        display: table-header-group;
    }

    #pdf-report tr {
        page-break-inside: avoid;
    }
}
</style>